import { render, staticRenderFns } from "./index.vue?vue&type=template&id=136a1232&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hero: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/base/Hero.vue').default,IconsActionsSearch: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/actions/Search.vue').default,IconsMap: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/Map.vue').default,IconsActionsReset: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/actions/Reset.vue').default,VacatureFilters: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/Filters.vue').default,VacatureCard: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/Card.vue').default,Pagination: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/base/Pagination.vue').default,VacatureLoader: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/Loader.vue').default,LayoutsSideView: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/layouts/SideView.vue').default,IconsActionsFilter: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/actions/Filter.vue').default})
